/* datas */
import { CountDatas } from '../Functions/CountDatas.js';
import { GetYear } from '../Functions/GetDates.js';
/* document */
import { GetStrTotal } from '../Functions/GetStrTotal.js';

export const BlockCollection = (props) => {
    const label = props.label;
    const datas = props.datas ? props.datas : [];
    const total = props.datas ? props.datas.length : 0;
    switch (label) {
        case 'home':
        case 'park':
            const uni = CountDatas('univers-attraction', props.att);
            return (
                <div className="list">
                    <div className="total">{`${total} ${GetStrTotal('univers', total)}`}</div>
                    {datas.map((el, i) => {
                        return (
                            <a className="link" href={el.uroute} alt={el.uname} title={el.uname} key={`i-${i}`}>
                                <div className="code"><i className="fa fa-link"></i></div>
                                <div className="name">
                                    <div>{el.uname}</div>
                                    <div className="note">{uni[el.uslug]}</div>
                                </div>
                            </a>
                        )
                    })}
                </div>
            )
        case 'categories':
            const cat = CountDatas('category-attraction', props.att);
            return (
                <div className="list">
                    <div className="total">{`${total} ${GetStrTotal('catégorie', total)}`}</div>
                    {datas.map((el, i) => {
                        return (
                            <a className="link" href={el.croute} alt={el.cname} title={el.cname} key={`i-${i}`}>
                                <div className="code" title={el.cname}><i className={el.ccode}></i></div>
                                <div className="name">
                                    <div>{el.cname}</div>
                                    <div className="note">{cat[el.cslug]}</div>
                                </div>
                            </a>
                        )
                    })}
                </div>
            )
        case 'univers':
        case 'attractions':
            return (
                <div className="list">
                    <div className="total">{`${total} ${GetStrTotal('attraction', total)}`}</div>
                    {datas.map((el, i) => {
                        return (
                            <a className="link" href={el.aroute} alt={el.aname} title={el.aname} key={`i-${i}`}>
                                <div className="code"><i className={el.ccode}></i></div>
                                <div className="name">{el.aname}</div>
                            </a>
                        )
                    })}
                </div>
            )
        case 'origins':
            const ori = CountDatas('origin-attraction', props.att);
            const cha = CountDatas('origin-personnage', props.cha);
            return (
                <div className="list">
                    <div className="total">{`${total} ${GetStrTotal('origine', total)}`}</div>
                    {datas.map((el, i) => {
                        return (
                            <a className="link" href={el.oroute} alt={el.oname} title={el.oname} key={`i-${i}`}>
                                <div className="date">{`${GetYear(el.ocreated)}`}</div>
                                <div className="name">
                                    <div>{el.oname}</div>
                                    <div className="note">{ori[el.oslug]}</div>
                                    <div className="note">{cha[el.oslug]}</div>
                                </div>
                            </a>
                        )
                    })}
                </div>
            )
        default:
            return (
                <></>
            )
    }
}